import wbClientSummaryTemplate from './client_summary.template.html';

angular.module('westBerkshireEvents.summary').component('wbClientSummary', {
    scope: {},
    templateUrl: wbClientSummaryTemplate.id,
    controllerAs: '$clientSummaryCtrl',
    bindings: {
        client: '<',
        event: '<'
    },
    controller: WbClientSummaryController
});

function WbClientSummaryController() {

}



// WEBPACK FOOTER //
// src/public/javascripts/client-summary/client_summary.component.js